





























































































































































import constants from '@/utils/constants'
import { Component, Watch, Vue, Prop } from 'vue-property-decorator'
import roles from '../roles.json'
@Component
export default class SideMenu extends Vue {
  @Prop(Boolean) isMobile!: boolean
  public routes: any[] = []

  get userType() {
    if (this.$store.state.currentUser) {
      return roles[this.$store.state.currentUser.Type.toLocaleLowerCase()]
    }
    return {}
  }

  get isEDC() {
    return this.$store.state.isEDC;
  }

  public handleToggle(value: string) {
    if (this.isMobile) {
      this.$emit('update-toggle', value)
    }
  }

  @Watch('isEDC', { immediate: true })
  watchIsEDC(val: boolean) {
    this.routes = [
      {
        route: '/',
        condition: this.userType['/'] !== constants.PERMISSION_N,
        label: 'Dashboard'
      },
      {
        route: '/sales-summary',
        condition: this.userType['/sales-summary'] !== constants.PERMISSION_N,
        label: 'Sales Report'
      },
      {
        route: '/change-order-status',
        condition:
          this.userType['/change-order-status'] === constants.PERMISSION_E,
        label: 'Change Order Status'
      },
      {
        route: '/order-report',
        condition: this.userType['/order-report'] !== constants.PERMISSION_N,
        label: 'Order list'
      },
      {
        route: '/waiting-list',
        condition: this.userType['/waiting-list'] !== constants.PERMISSION_N,
        label: 'Waiting list'
      },
      {
        route: '/download-orders',
        condition: this.userType['/download-orders'] !== constants.PERMISSION_N,
        label: 'Download Orders'
      },
      {
        route: '/customer-list',
        condition: this.userType['/customer-list'] !== constants.PERMISSION_N,
        label: 'Customer List'
      }
    ];
    if (val) {
      this.routes.unshift({
        route: '/edc',
        condition:
          this.userType['/edc'] !== constants.PERMISSION_N,
        label: 'Home Screen'
      })
    }
  }

  data(): {
    roles: any
    constants: any
    masterDataManagement: any[]
  } {
    return {
      roles,
      constants,
      masterDataManagement: [
        {
          id: 'collapse7',
          name: 'Master Data Management',
          list: [
            {
              id: 'collapse7-1',
              name: 'Outlet',
              list: [
                {
                  name: 'Outlet List',
                  router_link: '/stores'
                },
                {
                  name: 'Outlet Price',
                  router_link: '/outlet-price'
                },
                {
                  name: 'Upload store customer',
                  router_link: '/customer-batch-upload'
                }
              ]
            },
            {
              id: 'collapse7-2',
              name: ' Menu',
              list: [
                {
                  name: 'Menu Group',
                  router_link: '/menu-group'
                },
                {
                  name: 'Menu Group Limit',
                  router_link: '/menu-group-limit'
                },
                {
                  name: 'Menu Price',
                  router_link: '/menu-price'
                },
                {
                  name: 'Menu Item',
                  router_link: '/menu-item'
                },
                {
                  name: 'Menu Item Limit',
                  router_link: '/menu-item-limit'
                },

                {
                  name: 'Modifier Item',
                  router_link: '/modifier-item'
                },
                {
                  name: 'Modifier Price',
                  router_link: '/modifier-price'
                },
                {
                  name: 'Upload Menu Image',
                  router_link: '/menu-image-batch-upload'
                },
                {
                  name: 'Upload Menu',
                  router_link: '/menu-batch-upload'
                },
                {
                  name: 'Menu Variant Category',
                  router_link: '/variant-category'
                }
              ]
            },
            {
              id: 'collapse7-3',
              name: 'Schedule',
              list: [
                {
                  name: 'Menu Group Schedule',
                  router_link: '/menu-group-schedule'
                },
                {
                  name: 'Sale Menu Schedule',
                  router_link: '/sale-menu-schedule'
                },
                {
                  name: 'Outlet Open Schedule',
                  router_link: '/store-open-schedule'
                },
                {
                  name: 'Outlet Delivery Schedule',
                  router_link: '/store-delivery-schedule'
                }
              ]
            }
          ]
        }
      ]
    }
  }
}
